import GoalAchievedDialogController from "../components/goals/goal_achieved/GoalAchievedDialogController";
import GenericSnackbarController from "../components/generic/generic_snackbar/GenericSnackbarController";
import OnlineProvider from "./OnlineProvider";
import { Outlet } from "react-router-dom";
import NotificationProvider from "./NotificationProvider";
import React from "react";
import UserProvider from "./UserProvider";

const AppProviders: React.FC = () => {
  return (
    <NotificationProvider>
      <UserProvider>
        <OnlineProvider>
          <Outlet />
          <GenericSnackbarController />
          <GoalAchievedDialogController />
        </OnlineProvider>
      </UserProvider>
    </NotificationProvider>
  );
};

export default AppProviders;
